export const MainRoute = "/";
export const AlbumsRoute = `${MainRoute}albums`;
export const TracksRoute = `${MainRoute}tracks`;
export const ArtistsRoute = `${MainRoute}artists`;
export const ArtistsAlbumsRoute = `${MainRoute}artists/albums`;
export const ArtistsAlbumsTracksRoute = `${MainRoute}artists/albums/tracks`;
export const LyricsRoute = `${MainRoute}lyrics`;
